import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { ArrowDownIcon } from "@heroicons/react/24/solid";
import {
  Dialog,
  Card,
  CardHeader,
  Input,
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  Typography,
  Button,
  CardBody,
  CardFooter,
  IconButton,
  Tooltip,
  Select,
  Option,
  Checkbox,
} from "@material-tailwind/react";
import {
  createException,
  getallnonComplianceData,
  getUserData,
} from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import toast from "react-hot-toast";
import ExcelJS from "exceljs";
import TableRowWithShowMore from "../../components/TableRowWithShowMore";

export default function ListOfNonCompliances() {
  const { refreshToken } = useAuthUserToken();
  const [templateData, setTemplateData] = useState([]);
  console.log("🚀 ~ ListOfNonCompliances ~ templateData:", templateData);
  const [isLoading, setIsLoading] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [type, setType] = useState("cloud");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [reloadData, setReloadData] = useState(false);
  const [tableHead, setTableHead] = useState([
    "Name",
    "Type",
    "Status",
    "Compliance",
    "Risk Score",
    "Action",
  ]);

  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [userData, setUserData] = useState([]);
  const [errors, setErrors] = useState({ name: "" });
  const [bulk, setBulk] = useState(false);
  const [nextStep, setNextStep] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleBulk = () => {
    setBulk(!bulk);
  };

  const formSetData = {
    exceptionItem: [],
    exceptionStartDate: "",
    exceptionDuration: "",
    exceptionComment: "",
    exceptionApprover: "",
    exceptionItemCheck: [],
  };

  const [formData, setFormData] = useState(formSetData);

  const handleOpenCreateDialog = (_id) => {
    var uniqueSelectedIds;
    if (selectedIds) {
      uniqueSelectedIds = [...new Set(selectedIds)];
    }
    setOpenCreateDialog(true);
    setFormData((prevFormData) => ({
      ...prevFormData,
      exceptionItem: _id !== "" ? [_id] : uniqueSelectedIds,
    }));
  };
  const handleCloseDialog = () => {
    setOpenCreateDialog(false);
  };

  const handleCheckboxChange = (isChecked, _id) => {
    setSelectedIds((prevIds) => {
      if (isChecked) {
        setNextStep(true);
        return [...prevIds, _id];
      } else {
        return prevIds.filter((id) => id !== _id);
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeSelect = (e, fieldName) => {
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: e,
    }));
  };

  const handleBlur = () => {
    validateForm();
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.exceptionStartDate.trim())
      newErrors.exceptionStartDate = "Date is required";
    if (!formData.exceptionDuration.trim())
      newErrors.exceptionDuration = "Duration is required";
    if (!formData.exceptionComment.trim())
      newErrors.exceptionComment = "Comment is required";
    if (!formData.exceptionApprover.trim())
      newErrors.exceptionApprover = "Approver is required";
    setErrors(newErrors);
  };

  const handleTabChange = (value) => {
    setActiveTab(value);
    setType(value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    validateForm();
    if (Object.keys(errors).length === 0) {
      setIsLoadingButton(true);
      createException(refreshToken, formData)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success("Exception created successfully", {
              className: "text-[12px]",
            });
          } else if (response.code === 400) {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setIsLoadingButton(false);
          setFormData(formSetData);
          setErrors({ name: "" });
          setReloadData((cur) => !cur);
          setOpenCreateDialog((cur) => !cur);
        });
    } else {
      setIsLoadingButton(false);
    }
  };
  const [activeTab, setActiveTab] = useState("cloud");
  const data = [
    {
      label: "Cloud",
      value: "cloud",
    },
    {
      label: "Policy",
      value: "policy",
    },
    {
      label: "People",
      value: "people",
    },
    {
      label: "Vendor",
      value: "vendor",
    },
  ];

  useEffect(() => {
    if (userData.length === 0) {
      getUserData(refreshToken, "", "asc", 100, 1, "").then((data) => {
        setUserData(data?.data?.results);
      });
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);

    const tableHeaders = {
      cloud: [
        "Type",
        "Title",
        "Description",
        "Category",
        "Region",
        "Resource",
        "Status",
        "Output",
        "Select",
      ],
      policy: ["Policy Name", "Assignee", "Compliance", "LifeCycle", "Select"],
      people: [
        "Employment Status",
        "Name",
        "Emp ID",
        "Start Date",
        "End Date",
        "Select",
      ],
      vendor: ["Vendor Name", "Type", "Status", "Complaint Status"],
    };

    const fetchData = () => {
      getallnonComplianceData(refreshToken, sortBy, limit, page, type)
        .then((data) => {
          setIsLoading(true);
          setTemplateData(data?.data?.results);
          setTotalPage(data?.data?.totalPages);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    if (tableHeaders[activeTab]) {
      setTableHead(tableHeaders[activeTab]);
      fetchData();
    }
  }, [page, limit, sortBy, searchBy, activeTab, reloadData]);

  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("VendorManagement_Vendors Data");
    const headers = ["S.No.", "Vendor Name", "Type", "Status", "Compliance"];
    worksheet.addRow(headers);
    templateData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.vendorLegalName,
        row.vendorType,
        row.vendorStatus,
        row.vendorComplianceStatus,
      ]);
    });
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "vendorManagement_Vendors_data.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  const exportToExcelQ = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      "VendorManagement_Questionnaire Data"
    );
    const headers = [
      "S.No.",
      "QuestionnaireID",
      "QuestionnaireName",
      "Questionnaire Links",
    ];
    worksheet.addRow(headers);
    templateData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.questionnaireId,
        row?.questionnaireTitle,
        row?.questionnaireLinks,
      ]);
    });
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "vendorManagement_Questionnaire_data.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
  };

  return (
    <div className="app-main__inner !pl-20">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                List of Non-Compliances
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View non-compliances across all sources
              </Typography>
            </div>
            <div className="flex flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0">
              {activeTab === "vendors" ? (
                <Button
                  variant="outlined"
                  size="sm"
                  onClick={exportToExcel}
                  loading={isLoading === null ? true : false}
                >
                  <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
                </Button>
              ) : (
                <Button variant="outlined" size="sm" onClick={exportToExcelQ}>
                  <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
                </Button>
              )}

              <Button
                onClick={handleBulk}
                size="sm"
                loading={isLoading === null ? true : false}
                // className="flex items-center justify-center border-2 border-[#b0bec5] w-[150px] px-4 rounded-md text-black"
              >
                Bulk Execption
              </Button>
            </div>
          </div>
          <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
              <Select
                color="blue"
                label="Select Limit"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setLimit(event);
                  setIsLoading(null);
                }}
                value={limit}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
                <Option value={40}>40</Option>
                <Option value={50}>50</Option>
              </Select>
              <Select
                color="purple"
                label="Sort By"
                className="!border-t-0 !border-[#b0bec5]"
                onChange={(event) => {
                  setSortBy(event);
                  setIsLoading(null);
                }}
                value={sortBy}
              >
                <Option value="asc">Ascending</Option>
                <Option value="desc">Descending</Option>
              </Select>
            </div>
            <div className="w-full md:w-auto">
              <Input
                label="Search"
                value={searchBy}
                className="focus:!border-black focus:!border-2 focus:!border-t-0"
                onChange={(e) => setSearchBy(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
              />
            </div>
          </div>
        </CardHeader>
        <Tabs id="custom-animation" value={activeTab}>
          <TabsHeader className="mx-4 mt-4">
            {data.map(({ label, value }) => (
              <Tab
                key={value}
                value={value}
                onClick={() => handleTabChange(value)}
                className={activeTab === value ? "text-gray-900" : ""}
              >
                {label}
              </Tab>
            ))}
          </TabsHeader>
          <TabsBody
            animate={{
              initial: { y: 250 },
              mount: { y: 0 },
              unmount: { y: 250 },
            }}
          >
            {data?.map(({ value, desc }) => (
              <TabPanel key={value} value={value}>
                <CardBody className="overflow-scroll px-3 p-0">
                  <table className="mt-4 w-full min-w-max table-auto text-left">
                    <thead>
                      <tr>
                        {tableHead?.map((head, index) => (
                          <th
                            key={head}
                            className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50 w-32"
                          >
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                            >
                              {head}{" "}
                              {index !== tableHead.length - 1 && (
                                <ChevronUpDownIcon
                                  strokeWidth={2}
                                  className="h-4 w-4"
                                />
                              )}
                            </Typography>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    {isLoading ? (
                      <>
                        <tbody>
                          <tr>
                            <td colSpan={tableHead?.length}>
                              <TableSkeleton />
                            </td>
                          </tr>
                        </tbody>
                      </>
                    ) : (
                      <>
                        <tbody>
                          {isLoading === false && templateData?.length > 0 ? (
                            templateData?.map((item, index) => {
                              if (!item) return null;
                              let scanType,
                                testTitle,
                                testDescription,
                                cloudAssetCategory,
                                cloudAccountId,
                                cloudAssetRegion,
                                cloudAssetId,
                                testStatus,
                                testOutput,
                                _id,
                                employeeStatus,
                                employeeName,
                                employeeId,
                                employeeJoiningDate,
                                employeeLastDate,
                                vendorContactName,
                                vendorType,
                                vendorStatus,
                                vendorCompliantStatus;
                              if (activeTab === "cloud") {
                                ({
                                  scanType,
                                  testTitle,
                                  testDescription,
                                  cloudAssetCategory,
                                  cloudAccountId,
                                  cloudAssetRegion,
                                  cloudAssetId,
                                  testStatus,
                                  testOutput,
                                  _id,
                                } = item);
                              } else if (activeTab === "people") {
                                ({
                                  employeeStatus,
                                  employeeName,
                                  employeeId,
                                  employeeJoiningDate,
                                  employeeLastDate,
                                } = item);
                              } else if (activeTab === "vendor") {
                                ({
                                  vendorContactName,
                                  vendorType,
                                  vendorStatus,
                                  vendorCompliantStatus,
                                } = item);
                              }
                              const isLast = index === templateData.length - 1;
                              const classes = isLast
                                ? "p-4"
                                : "p-4 border-b border-blue-gray-50";

                              return (
                                (activeTab === "cloud" && (
                                  <tr key={`${_id}-${index}`}>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {scanType}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {testTitle}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      {testDescription?.length > 40 ? (
                                        <TableRowWithShowMore
                                          data={testDescription}
                                        />
                                      ) : (
                                        testDescription
                                      )}
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {cloudAssetCategory}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {cloudAssetRegion}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      {cloudAssetId?.length > 40 ? (
                                        <TableRowWithShowMore
                                          data={cloudAssetId}
                                        />
                                      ) : (
                                        cloudAssetId
                                      )}
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {testStatus}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {testOutput}
                                      </Typography>
                                    </td>
                                    {bulk ? (
                                      <>
                                        <td className="flex items-center justify-center mt-4">
                                          <Checkbox
                                            id="ripple-on"
                                            key={_id}
                                            // id={`checkbox-${_id}-${index}`}
                                            ripple={true}
                                            className="!border !border-black"
                                            onChange={(e) =>
                                              handleCheckboxChange(
                                                e.target.checked,
                                                _id
                                              )
                                            }
                                          />
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td className={classes}>
                                          <Button
                                            variant="gradient"
                                            size="sm"
                                            onClick={() =>
                                              handleOpenCreateDialog(_id)
                                            }
                                          >
                                            Req Exception
                                          </Button>
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                )) ||
                                (activeTab === "policy" && (
                                  <tr key={`${_id}-${index}`}>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        Policy Name
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        Assignee
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        Compliance
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        LifeCycle
                                      </Typography>
                                    </td>
                                    {bulk ? (
                                      <>
                                        <td className="flex items-center justify-center mt-4">
                                          <Tooltip
                                            className="bg-blue-gray-500"
                                            content="Toggle Checkbox"
                                          >
                                            <input
                                              key={_id}
                                              id={`checkbox-${_id}-${index}`}
                                              type="checkbox"
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e.target.checked,
                                                  _id
                                                )
                                              }
                                              value=""
                                              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            />
                                          </Tooltip>
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td className={classes}>
                                          <button
                                            onClick={() =>
                                              handleOpenCreateDialog(_id)
                                            }
                                            className="bg-blue-800 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded"
                                          >
                                            Req Exception
                                          </button>
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                )) ||
                                (activeTab === "people" && (
                                  <tr key={`${_id}-${index}`}>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {employeeStatus}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {employeeName}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {employeeId}
                                      </Typography>
                                    </td>
                                    {/* <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        
                                      </Typography>
                                    </td> */}
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {employeeJoiningDate}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {employeeLastDate}
                                      </Typography>
                                    </td>
                                    {bulk ? (
                                      <>
                                        <td className="flex items-center justify-center mt-4">
                                          <Checkbox
                                            id="ripple-on"
                                            key={_id}
                                            // id={`checkbox-${_id}-${index}`}
                                            ripple={true}
                                            className="!border !border-black"
                                            onChange={(e) =>
                                              handleCheckboxChange(
                                                e.target.checked,
                                                _id
                                              )
                                            }
                                          />
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td className={classes}>
                                          <Button
                                            variant="gradient"
                                            size="sm"
                                            onClick={() => {
                                              handleOpenCreateDialog(_id);
                                            }}
                                          >
                                            Req Exception
                                          </Button>
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                )) ||
                                (activeTab === "vendor" && (
                                  <tr key={`${_id}-${index}`}>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {vendorContactName}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {vendorType}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {vendorStatus}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        {vendorCompliantStatus}
                                      </Typography>
                                    </td>
                                    {/* <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal"
                                      >
                                        Risk Score
                                      </Typography>
                                    </td> */}
                                    {/* {bulk ? (
                                      <>
                                        <td className="flex items-center justify-center mt-4">
                                          <Tooltip
                                            className="bg-blue-gray-500"
                                            content="Toggle Checkbox"
                                          >
                                            <input
                                              key={_id}
                                              id={`checkbox-${_id}-${index}`}
                                              type="checkbox"
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e.target.checked,
                                                  _id
                                                )
                                              }
                                              value=""
                                              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            />
                                          </Tooltip>
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td className={classes}>
                                          <button
                                            onClick={() =>
                                              handleOpenCreateDialog(_id)
                                            }
                                            className="bg-blue-800 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded"
                                          >
                                            Req Exception
                                          </button>
                                        </td>
                                      </>
                                    )} */}
                                  </tr>
                                ))
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="8">
                                <div className="flex flex-col items-center w-full">
                                  <img
                                    quality={100}
                                    src="/assets/images/9276430.jpg"
                                    className="w-[350px] mix-blend-darken"
                                    alt="no-data-found"
                                  />
                                  <p className="text-[20px] font-medium">
                                    No Data Found!
                                  </p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </>
                    )}
                  </table>
                </CardBody>
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
        {isLoading === null ? null : (
          <>
            <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
              <Button
                variant="outlined"
                size="sm"
                onClick={() => {
                  setPage(page - 1);
                  setIsLoading(null);
                }}
                disabled={totalPage > 1 ? false : true}
              >
                Previous
              </Button>

              <div className="flex items-center gap-2">
                {Array.from({ length: totalPage }, (_, index) => (
                  <IconButton
                    key={index + 1}
                    variant={index + 1 === page ? "outlined" : "text"}
                    size="sm"
                    onClick={() => {
                      setPage(index + 1);
                      setIsLoading(null);
                    }}
                    disabled={totalPage > 1 ? false : true}
                  >
                    {index + 1}
                  </IconButton>
                ))
                  .reduce((acc, button, index, array) => {
                    if (
                      index < 3 ||
                      index >= totalPage - 3 ||
                      (index >= Math.max(page - 1, 3) &&
                        index <= Math.min(page + 1, totalPage - 4))
                    ) {
                      acc.push(button);
                    } else if (acc[acc.length - 1] !== "ellipsis") {
                      acc.push("ellipsis");
                    }
                    return acc;
                  }, [])
                  .map((element, index, array) => {
                    return element === "ellipsis" ? (
                      <IconButton
                        key={`ellipsis-${index}`}
                        variant="text"
                        size="sm"
                        disabled
                      >
                        ...
                      </IconButton>
                    ) : index > 0 && array[index - 1] === "ellipsis" ? (
                      <React.Fragment key={`fragment-${index}`}>
                        {element}
                      </React.Fragment>
                    ) : (
                      element
                    );
                  })}
              </div>

              <div className="flex items-center justify-between gap-2">
                {nextStep && (
                  <Button
                    className="bg-blue-600 text-white"
                    onClick={() => {
                      handleOpenCreateDialog("");
                    }}
                    variant="outlined"
                    size="sm"
                  >
                    Next Step
                  </Button>
                )}
                <Button
                  variant="outlined"
                  size="sm"
                  onClick={() => {
                    setPage(page + 1);
                    setIsLoading(null);
                  }}
                  disabled={totalPage > 1 ? false : true}
                >
                  Next
                </Button>
              </div>
            </CardFooter>
          </>
        )}
      </Card>

      {/* Dailog Box */}
      <Dialog
        size="lg"
        open={openCreateDialog}
        handler={handleCloseDialog}
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <form onSubmit={handleSubmit}>
          <Card className="mx-auto w-full p-2">
            <CardBody className="flex flex-col gap-4">
              <Typography variant="h4" color="blue-gray">
                Add New
              </Typography>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Input
                    type="text"
                    label="Exception Item"
                    size="lg"
                    name="exceptionItem"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                    value={formData?.exceptionItem}
                  />
                  {errors.exceptionItem && (
                    <p className="text-red-900 text-[12px]">
                      {errors.exceptionItem}
                    </p>
                  )}
                </div>
                <div>
                  <Input
                    type="date"
                    label="Exception StartDate"
                    size="lg"
                    name="exceptionStartDate"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.exceptionStartDate && (
                    <p className="text-red-900 text-[12px]">
                      {errors.exceptionStartDate}
                    </p>
                  )}
                </div>
                <div>
                  <Select
                    label="Select Execption Duration"
                    onChange={(e) => handleChangeSelect(e, "exceptionDuration")}
                    onBlur={handleBlur}
                    name="exceptionDuration"
                    color="purple"
                  >
                    <Option value="">Select Type</Option>
                    <Option value="monthly">Monthly</Option>
                    <Option value="yearly">Yearly</Option>
                    <Option value="quaterly">Quaterly</Option>
                  </Select>
                  {errors.exceptionDuration && (
                    <p className="text-red-900 text-[12px]">
                      {errors.exceptionDuration}
                    </p>
                  )}
                </div>
                <div>
                  <Input
                    type="text"
                    label="Exception Comment"
                    size="lg"
                    name="exceptionComment"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                  />
                  {errors.exceptionComment && (
                    <p className="text-red-900 text-[12px]">
                      {errors.exceptionComment}
                    </p>
                  )}
                </div>
                <div>
                  <Select
                    label="Select Approver"
                    color="purple"
                    name="exceptionApprover"
                    onChange={(e) => handleChangeSelect(e, "exceptionApprover")}
                    onBlur={handleBlur}
                  >
                    {userData.map((resp, index) => (
                      <Option key={index} value={resp?._id}>
                        {resp?.fullName}
                      </Option>
                    ))}
                  </Select>
                  {errors.exceptionApprover && (
                    <p className="text-red-900 text-[12px]">
                      {errors.exceptionApprover}
                    </p>
                  )}
                </div>
              </div>
            </CardBody>
            <CardFooter className="flex justify-end border-t-2 py-2">
              <Button
                variant="text"
                color="red"
                onClick={handleCloseDialog}
                className="mr-1"
              >
                <span>Cancel</span>
              </Button>

              <Button
                variant="gradient"
                type="submit"
                loading={isLoadingButton}
                color="green"
              >
                <span>Submit</span>
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Dialog>
    </div>
  );
}
